module.exports = {
          srcSet: __webpack_public_path__ + "98e4b8056e5ab3bcf36ce0e582cc6a83-160.png"+" 160w",
          images:[ {path: __webpack_public_path__ + "98e4b8056e5ab3bcf36ce0e582cc6a83-160.png",width: 160,height: 160}],
          src: __webpack_public_path__ + "98e4b8056e5ab3bcf36ce0e582cc6a83-160.png",
          toString:function(){return __webpack_public_path__ + "98e4b8056e5ab3bcf36ce0e582cc6a83-160.png"},
          
          width: 160,
          height: 160
        }